import { DEFAULT_GEO_DATA_NORMALIZER } from './geo-constants';
export function getGeoDefaultCountryConfig() {
    return {
        SUPPORT: {
            DIV_2: false,
            DIV_1: false,
            ZIP: false,
        },
        LABEL: {
            DIV_1: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.STATE',
            DIV_2: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.DISTRICT',
            ZIP: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.ZIP_CODE',
        },
        NORMALIZER: {
            DIV_1: DEFAULT_GEO_DATA_NORMALIZER,
            DIV_2: DEFAULT_GEO_DATA_NORMALIZER,
            ZIP: DEFAULT_GEO_DATA_NORMALIZER,
        },
        EXTRA_FIELDS: {
            DIV_1: [],
            DIV_2: [],
        },
    };
}
//# sourceMappingURL=geo-country-default-config.js.map